import { Divider } from '@mui/material';

// Menu children can not be empty fragments, only <MenuItem> or <li> components, and must have keys when mapped
export const interleaveMenuDivider = (elements) =>
  [].concat(...elements.map((el, i) => [el, <Divider key={`menu-divider-${i}`} aria-hidden component="li" />])).slice(0, -1);
